<template>
    <div v-if="meio" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes do Meio de Pagamento</h4>
        <router-link to="/financeiro/parametros/meios">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <div class="form-content mt-3">
        <FormSection title="">
          <p><strong>Operador:</strong> {{ meio.nome_operador || 'Não informado' }}</p>
          <p><strong>Meio:</strong> {{ meio.meio || 'Não informado' }}</p>
          <p><strong>Criado em:</strong> {{ formatDate(meio?.criado_em) }}</p>
          <p><strong>Atualizado em:</strong> {{ formatDate(meio?.atualizado_em) }}</p>
        </FormSection>
      </div>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import FormSection from "@/components/Layout/FormSection.vue";
  
  export default {
    components: { FormSection },
    data() {
      return {
        meio: null,
      };
    },
    methods: {
      async carregarDetalhesMeio() {
        try {
          const response = await axios.get(
            `/financeiro/parametros/meios/${this.$route.params.id}`
          );
          this.meio = response.data;
        } catch (error) {
          console.error("Erro ao carregar os detalhes do meio:", error);
        }
      },
      formatDate(data) {
        if (!data) return "Não informado";
        return new Date(data).toLocaleString();
      },
    },
    mounted() {
      this.carregarDetalhesMeio();
    },
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0rem;
  }
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left;
  }
  .form-content {
    margin-top: 1.5rem;
  }
  button.btn-sm {
    padding: 6px 12px;
  }
  </style>
  